module.exports = __webpack_public_path__ + "img/about-site.4af55a14.png";